<script setup>
import FAQ from "~/components/templates/FAQ.vue";
import Text from "~/components/atoms/Text.vue";
import HorizontalMenu from "~/components/molecules/HorizontalMenu.vue";
import SpoilerTabs from "~/components/molecules/SpoilerTabs.vue";
import PluginsPage from "~/components/templates/PluginsPage.vue";
import Plugin from "~/components/organisms/Plugin.vue";
import Heading from "~/components/atoms/Heading.vue";
import Breadcrumbs from "~/components/organisms/Breadcrumbs.vue";

const {t} = useI18n();

const props = defineProps({
  data: Array,
})

useSeoMeta({
  title: props.data.meta_title,
  description: props.data.meta_description,
})

const menu = [
  {
    image: '/svg/icons/calculator.svg',
    title: t('menu.items.calculator.title'),
    link: t('menu.items.calculator.link'),
  },
  {
    image: '/svg/icons/calculator.svg',
    title: t('menu.items.tile_calculator.title'),
    link: t('menu.items.tile_calculator.link'),
  }
]
const menu2 = [
  {
    title: t('menu.items.grout_tiles.title'),
    link: t('menu.items.grout_tiles.link'),
  },
  {
    title: t('menu.items.drill_in_tiles.title'),
    link: t('menu.items.drill_in_tiles.link'),
  },
  {
    title: t('menu.items.lay_wooden_tiles.title'),
    link: t('menu.items.lay_wooden_tiles.link'),
  },
  {
    title: t('menu.items.clean_tiles.title'),
    link: t('menu.items.clean_tiles.link'),
  },
  {
    title: t('menu.items.remove_tiles.title'),
    link: t('menu.items.remove_tiles.link'),
  },
  {
    title: t('menu.items.difference_tiles.title'),
    link: t('menu.items.difference_tiles.link'),
  }
]

useHead({
  script: [
    {
      type: 'application/ld+json',
      children: props.data.breadcrumbs_structured_data
    }
  ]
})
</script>

<template>
  <FAQ>
    <div class="g-32">
      <Breadcrumbs :breadcrumbs="data.breadcrumbs"/>

      <Heading class="title" font-size="32px">{{ props.data.name }}</Heading>
    </div>

    <template #menu>
      <div class="g-24" v-if="$device.isDesktop">
        <div class="g-24">
          <Text tag="b">{{ $t('tips.calculator') }}</Text>

          <nav>
            <HorizontalMenu :no-padding="true" :is-vertical="true"
                            :hide-on-mobile="false"
                            :items="menu"/>
          </nav>
        </div>
        <hr>
        <div class="g-24">
          <Text tag="b">{{ $t('tips.tips') }}</Text>

          <nav>
            <HorizontalMenu :no-padding="true" :is-vertical="true"
                            :items="menu2"/>
          </nav>
        </div>
      </div>
      <div v-else>
        <SpoilerTabs :classic-separator="false" :bold="true" :arrows="false"
                     :tabs="[$t('tips.calculator'),$t('tips.tips')]">
          <template v-slot:tab-content-0>
            <nav>
              <HorizontalMenu :no-padding="true" style="flex-direction: column; align-items: flex-start; gap:14px;"
                              :hide-on-mobile="false"
                              :items="menu"/>
            </nav>
          </template>
          <template v-slot:tab-content-1>
            <nav>
              <HorizontalMenu :no-padding="true" :hide-on-mobile="false"
                              style="flex-direction: column; align-items: flex-start; gap:14px;"
                              :items="menu2"/>
            </nav>
          </template>
        </SpoilerTabs>
      </div>
    </template>

    <template #plugins>
      <PluginsPage>
        <template v-slot:[position] v-for="[position, plugins] of Object.entries(props.data.grouped_plugins)">
          <template v-for="plugin in plugins">
            <Plugin :data="plugin.data" :name="plugin.name" :settings="plugin.settings"/>
          </template>
        </template>
      </PluginsPage>
    </template>
  </FAQ>
</template>

<style scoped lang="scss">

.title {
  margin-bottom: 24px;
}

</style>
